import { useCallback } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useCallIntelLocations } from '../hooks/use-call-intel-locations';
import {
  formatInferencesChartData,
  formatOpportunitiesChartData,
  formatSchedulingChartData,
  getAllInferencesList,
} from './format-chart-data';
import { InferencesChartData, OpportunitiesFormattedData, SchedulingFormattedData } from './types';

type InferenceLocationValue = { inferences: Record<string, number> } | Record<string, number>;

export const useChartDataFormatter = () => {
  const { locations } = useCallIntelLocations();

  const formatInferences = useCallback(
    (data: Record<string, InferenceLocationValue> | undefined, prefillHelper: string[]): InferencesChartData =>
      formatInferencesChartData(locations, data, prefillHelper),
    [locations]
  );

  const formatOpportunities = useCallback(
    (
      data: CallIntelTypes.CallsViewByLocation['opportunitiesByLocation'] | undefined,
      sentimentsByLocation: InferencesChartData
    ): OpportunitiesFormattedData => formatOpportunitiesChartData(locations, data, sentimentsByLocation),
    [locations]
  );

  const formatScheduling = useCallback(
    (data: CallIntelTypes.CallsViewByLocation['schedulingStatsByLocation'] | undefined): SchedulingFormattedData =>
      formatSchedulingChartData(locations, data),
    [locations]
  );

  return { formatInferences, formatOpportunities, formatScheduling, getAllInferencesList };
};
